import * as React from "react";
import { Skeleton } from "@mui/material";
import { MediaPlayerConsoleStyled } from "../media-player-console";

const MediaPlayerConsoleSkeleton: React.FC = () => {
  return (
    <MediaPlayerConsoleStyled.StyledStack flexDirection="row" width="100%">
      <MediaPlayerConsoleStyled.MediaPlayer>
        <Skeleton variant="rectangular" height="100%" />
      </MediaPlayerConsoleStyled.MediaPlayer>
      <MediaPlayerConsoleStyled.Console>
        <MediaPlayerConsoleStyled.ConsoleBody>
          <Skeleton height={40} width="90%" />
          <Skeleton height={40} width="70%" />
          <Skeleton height={40} />
        </MediaPlayerConsoleStyled.ConsoleBody>
      </MediaPlayerConsoleStyled.Console>
    </MediaPlayerConsoleStyled.StyledStack>
  );
};

export default MediaPlayerConsoleSkeleton;
